import { ApolloLink } from '@apollo/client';
import { isNil, omitBy } from 'lodash';
import { AuthService, Logger } from '@indigo-ag/ui-core';

export const getAuthMiddlewareLink = (): ApolloLink => {
  return new ApolloLink((operation, forward: any) => {
    const token = AuthService.getIdToken();
    if (!token) {
      Logger.log('Unable to retrieve auth token.');
    }

    operation.setContext(({ headers = {} }) => ({
      headers: omitBy(
        {
          ...headers,
          authorization: token ? `Bearer ${token}` : null
        },
        isNil
      )
    }));

    return forward(operation);
  });
};
